const dropdowns = {streetType : [
    "Avenue",
    "Boulevard",
    "Circle",
    "Crescent",
    "Drive",
    "Gate",
    "Highway",
    "Lane",
    "Line",
    "Road",
    "Route",
    "Street",
    "Terrace",
    "Trail",
    "Way",
    "Common",
    "Court",
    "Green",
    "Manor",
    "Place",
    "Rise",
    "Landing",
    "Bay",
    "Close",
    "Link",
    "Mews",
    "View",
    "Quay",
    "Square",
    "Abbey",
    "Acres",
    "Alley",
    "Autoroute",
    "Beach",
    "Bend",
    "By-Pass",
    "Byway",
    "Campus",
    "Cape",
    "Centre",
    "Chase",
    "Circuit",
    "Concession",
    "Corners",
    "Crossing",
    "Cul-de-sac",
    "Cove",
    "Dale",
    "Dell",
    "Diversion",
    "Downs",
    "End",
    "Estates",
    "Expressway",
    "Extension",
    "Farm",
    "Field",
    "Forest",
    "Freeway",
    "Front",
    "Gardens",
    "Glade",
    "Glen",
    "Grounds",
    "Grove",
    "Harbour",
    "Heights",
    "Highlands",
    "Hill",
    "Hollow",
    "Impasse",
    "Island",
    "Key",
    "Knoll",
    "Limits",
    "Lookout",
    "Loop",
    "Mall",
    "Maze",
    "Meadow",
    "Moor",
    "Mount",
    "Mountain",
    "Orchard",
    "Parade",
    "Park",
    "Parkway",
    "Passage",
    "Path",
    "Pathway",
    "Pines",
    "Plaza",
    "Point",
    "Port",
    "Private",
    "Promenade",
    "Range",
    "Ridge",
    "Row",
    "Run",
    "Subdivision",
    "Thicket",
    "Towers",
    "Townline",
    "Turnabout",
    "Vale",
    "Village",
    "Vista",
    "Walk",
    "Wharf",
    "Wood",
    "Heath",
    "Inlet",
    "Plateau",
    "Ramp",
    "Villas",
    "Wynd",
    "Allée",
    "Carré",
    "Carrefour",
    "Cercle",
    "Chemin",
    "Côte",
    "Cour",
    "Cours",
    "Croissant",
    "Échangeur",
    "Esplanade",
    "Île",
    "Montée",
    "Parc",
    "Pointe",
    "Quai",
    "Rang",
    "Rond-point",
    "Rue",
    "Ruelle",
    "Sentier",
    "Terrasse",
    "Via",
    "Villas",
    "Voie",
    "Alley",
    "Annex",
    "Arcade",
    "Avenue",
    "Bayou",
    "Beach",
    "Bend",
    "Bluff",
    "Bluffs",
    "Bottom",
    "Boulevard",
    "Branch",
    "Bridge",
    "Brook",
    "Brooks",
    "Burg",
    "Burgs",
    "Bypass",
    "Camp",
    "Canyon",
    "Cape",
    "Causeway",
    "Center",
    "Centers",
    "Circle",
    "Circles",
    "Cliff",
    "Cliffs",
    "Club",
    "Common",
    "Commons",
    "Corner",
    "Corners",
    "Course",
    "Court",
    "Courts",
    "Cove",
    "Coves",
    "Creek",
    "Crescent",
    "Crest",
    "Crossing",
    "Crossroad",
    "Crossroads",
    "Curve",
    "Dale",
    "Dam",
    "Divide",
    "Drive",
    "Drives",
    "Estate",
    "Estates",
    "Expressway",
    "Extension",
    "Extensions",
    "Fall",
    "Falls",
    "Ferry",
    "Field",
    "Fields",
    "Flat",
    "Flats",
    "Ford",
    "Fords",
    "Forest",
    "Forge",
    "Forges",
    "Fork",
    "Forks",
    "Fort",
    "Freeway",
    "Garden",
    "Gardens",
    "Gateway",
    "Glen",
    "Glens",
    "Green",
    "Greens",
    "Grove",
    "Groves",
    "Harbor",
    "Harbors",
    "Haven",
    "Heights",
    "Highway",
    "Hill",
    "Hills",
    "Hollow",
    "Inlet",
    "Island",
    "Islands",
    "Isle",
    "Junction",
    "Junctions",
    "Key",
    "Keys",
    "Knoll",
    "Knolls",
    "Lake",
    "Lakes",
    "Land",
    "Landing",
    "Lane",
    "Light",
    "Lights",
    "Loaf",
    "Lock",
    "Locks",
    "Lodge",
    "Loop",
    "Mall",
    "Manor",
    "Manors",
    "Meadow",
    "Meadows",
    "Mews",
    "Mill",
    "Mills",
    "Mission",
    "Motorway",
    "Mount",
    "Mountain",
    "Mountains",
    "Neck",
    "Orchard",
    "Park",
    "Parks",
    "Parkway",
    "Parkways",
    "Pass",
    "Passage",
    "Path",
    "Pike",
    "Pine",
    "Pines",
    "Place",
    "Plain",
    "Plains",
    "Plaza",
    "Point",
    "Points",
    "Port",
    "Ports",
    "Prairie",
    "Radial",
    "Ramp",
    "Ranch",
    "Rapid",
    "Rapids",
    "Rest",
    "Ridge",
    "Ridges",
    "River",
    "Road",
    "Roads",
    "Route",
    "Row",
    "Rue",
    "Run",
    "Shoal",
    "Shoals",
    "Shore",
    "Shores",
    "Skyway",
    "Spring",
    "Springs",
    "Spur",
    "Spurs",
    "Square",
    "Squares",
    "Station",
    "Stravenue",
    "Stream",
    "Street",
    "Streets",
    "Summit",
    "Terrace",
    "Throughway",
    "Trace",
    "Track",
    "Trafficway",
    "Trail",
    "Trailer",
    "Tunnel",
    "Turnpike",
    "Underpass",
    "Union",
    "Unions",
    "Valley",
    "Valleys",
    "Viaduct",
    "View",
    "Views",
    "Village",
    "Villages",
    "Ville",
    "Vista",
    "Walk",
    "Walks",
    "Wall",
    "Way",
    "Ways",
    "Well",
    "Wells"
  ],
  relationshipToApplicant: [
    "Applicant",
    "Co Signer",
    "Guarantor",
  ],
  streetDirection: [
    "N",
    "S",
    "E",
    "W",
    "NE",
    "NW",
    "SE",
    "SW",
  ],
  provincesAndStates: [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Northwest Territories",
    "Nova Scotia",
    "Nunavut",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
    "Yukon",
    "Alabama",
    "Alaska",
    "American Samoa",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District of Columbia",
    "Federated States of Micronesia",
    "Florida",
    "Georgia",
    "Guam",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Marshall Islands",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Northern Mariana Islands",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Palau",
    "Pennsylvania",
    "Puerto Rico",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virgin islands",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
    "Armed Forces Americas (except Canada)",
    "Armed Forces Europe, Africa, The Middle East and Canada",
    "Armed Forces Pacific"
  ],
  residentialStatus:[
    "Own",
    "Rent",
    "Live With Parents",
    "Other"
  ],
  maritalStatus:[
    "Married",
    "Common Law",
    "Never Married",
    "Widowed",
    "Separated",
    "Annulled",
    "Divorced",
  ],
  salutation:[
    "Mr.",
    "Mrs.",
    "Ms.",
    "Dr.",
    "Rev.",
    "Miss",
    "Judge"
  ],
  suffix:[
    "Sr.",
    "Jr."
  ],
  preferredContactMethod:[
    "Home Phone",
    "Cell Phone",
    "Fax",
    "E-mail",
    "Work Phone",
    "Mail"
  ],
  bankruptcyStatus:[
    "Never Bankrupt",
    "Fully Discharged",
    "Partially Discharged"
  ],
  citizenshipType:[
    "Citizen",
    "Unknown",
    "Resident",
    "Landed Immigrant",
    "Foreign Alien",
    "Student Visa",
    "Work Visa",
    "Non Resident"
  ],
  identificationSource: [
    "Birth Certificate",
    "Driver&amp;apos;s License",
    "Health Insurance Card",
    "Old Age Security Card",
    "Social Insurance Card",
    "Certificate of Naturalization",
    "Citizenship Certificate",
    "Green Card",
    "IMM 1000 Immigration Form",
    "IMM 1442 Citizenship and Immigration Canada",
    "Passport",
    "Permanent Resident Card or IMM5292",
    "Alberta Registries",
    "Dept. of Community Govt. and Trans.",
    "Dept. of Govt. Services and Lands NL",
    "Dept. of Service of NS and Municipal Relations",
    "Dept. of Trans. and Public Works PEI",
    "Government of the NT Dept. of Trans.",
    "Insurance Corporation of BC",
    "Saskatchewan Government Insurance",
    "Service New Brunswick",
    "ABM card or Client Card",
    "Client Card from the CNIB",
    "Credit Card",
    "Employee ID Card",
    "Other",
  ],
  relationshipToPrimaryApplicant:[
    "Spouse",
    "Common-Law",
    "Related Family Member",
    "Other",
    "Parent",
    "Sibling",
    "Child",
    "Grandchild",
    "Grandparent"
  ],
  assetType:[
    "Savings",
    "RRSP",
    "Gift",
    "Vehicle",
    "Stocks/Bonds/Mutual",
    "Other",
    "Household Goods",
    "Life Insurance",
    "Deposit on Purchase"
  ],
  creditBureauName:[
    "Equifax",
    "TransUnion"
  ],
  dealNoteCategory:[
    "General",
    "Admin",
    "Source of Business",
    "Decisioning",
    "MI Response",
    "Deal Ingestion"
  ],
  dealPurpose:[
    "Purchase",
    "Purchase + Improvements",
    "Refinance",
    "ETO",
    "Switch / Transfer",
    "Port",
    "Deficiency Sale",
    "Workout"
  ],
  dealType:[
    "Approval",
    "Pre-Approval"
  ],
  downPaymentSourceType:[
    "Sale of Existing Property",
    "Personal Cash",
    "RRSP",
    "Borrowed Against Liquid Assets",
    "Gift",
    "Sweat Equity",
    "Other",
    "Existing Equity",
    "Secondary Financing",
    "Grants"
  ],
  employmentType:[
    "Full Time",
    "Part Time",
    "Seasonal"
  ],
  industrySector:[
    "Other",
    "Construction",
    "Government",
    "Health",
    "Education",
    "High-Tech",
    "Retail Sales",
    "Leisure/Entertainment",
    "Banking/Finance",
    "Transportation",
    "Services",
    "Manufacturing",
    "Farming/Natural Resources",
    "Varies"
  ],
  occupation:[
    "Other",
    "Management",
    "Clerical",
    "Labour/Tradesperson",
    "Retired",
    "Professional",
    "Self-Employed"
  ],
  incomePeriod:[
    "Annual",
    "Semi-Annual",
    "Quarterly",
    "Monthly",
    "Semi-Monthly",
    "Bi-Weekly",
    "Weekly"
  ],
  incomeType:[
    "Salary",
    "Hourly",
    "Hourly + Commissions",
    "Commissions",
    "Self-Employed",
    "Other Employment Income",
    "Rental Income",
    "Interest Income",
    "Child Support",
    "Pension",
    "Alimony",
    "Other"
  ],
  liabilityPayOffType:[
    "Prior to Advance",
    "From Proceeds"
  ],
  liabilityType:[
    "Credit Card",
    "Personal Loan",
    "Auto Loan",
    "Alimony",
    "Child Support",
    "Student Loan",
    "Wage Garnishment",
    "Other",
    "Unsecured Line of Credit",
    "Income Tax",
    "Secured Line of Credit",
    "Lease",
    "Auto Lease"
  ],
  interestCompound: [
    "Semi Annually",
    "Monthly"
  ],
  repaymentType:[
    "Blended PI",
    "Interest Plus Fixed Principal",
    "Interest Only Variable",
    "Interest Only Fixed",
    "At Maturity"
  ],
  interestType:[
    "Fixed",
    "Adjustable",
    "Capped Variable",
    "Variable",
    "Buydown"
  ],
  loanType:[
    "Mortgage",
    "Secured LOC",
    "Multiple Component"
  ],
  mortgageInsurerID:[
    "CMHC",
    "Genworth",
    "Canada Guaranty"
  ],
  mortgageType:[
    "First",
    "Second",
    "Third"
  ],
  mortgageProduct: [
    "Full Service",
    "Basic Service",
    "Partial Coverage",
    "Cash Back",
    "Flex Down",
    "Alt A Upfront Premium",
    "Family Plan",
    "New in Canada",
    "Staff application",
    "Spousal Buyout",
    "Vacation Home",
    "Equity Assist",
    "Low Doc",
    "Equity Guide",
    "CMHC Self-Employed Simplified",
    "Chattel Loan Insurance"
  ],
  paymentFrequency:[
    "Monthly",
    "Semi Monthly",
    "Biweekly",
    "Accelerated Biweekly",
    "Weekly",
    "Accelerated Weekly"
  ],
  paymentTerm:[
    "Closed",
    "Open",
    "Convertible"
  ],
  partyType:[
    "Solicitor",
    "Appraiser",
    "Solicitor Network",
    "Referral Source",
    "Service Branch"
  ],
  dwellingStyle:[
    "One Storey",
    "Bi-Level",
    "Two Storey",
    "Split Level",
    "Storey and a Half",
    "Three Storey",
    "Other"
  ],
  dwellingType:[
    "Detached",
    "Semi-Detached",
    "Duplex - Detached",
    "Duplex - Semi-Detached",
    "Row Housing",
    "Apartment Low Rise",
    "Apartment High Rise",
    "Mobile",
    "Tri Plex - Detached",
    "Tri Plex - Semi-Detached",
    "Stacked",
    "Modular Home - Detached",
    "Modular Home - Semi-Detached",
    "Four Plex - Detached",
    "Four Plex - Semi-Detached"
  ],
  garageSize:[
    "Single",
    "Double",
    "Triple",
    "None"
  ],
  garageType:[
    "Attached",
    "Detached"
  ],
  heatType:[
    "Electric Baseboard",
    "Forced Air Gas/Oil/Electric",
    "Hot Water Heating",
    "Other"
  ],
  unitOfMeasure:[
    "Sq m",
    "Sq ft",
    "Acres",
    "Hectares"
  ],
  occupancyType:[
    "Owner-Occupied",
    "Owner-Occupied Rental",
    "Second Home"
  ],
  propertyType:[
    "FreeHold",
    "LeaseHold",
    "Condo"
  ],
  sewageType:[
    "Municipal",
    "Septic",
    "HoldingTank"
  ],
  propertyExpenseType:[
    "Municipal Taxes",
    "Condo Fees",
    "Heating Expense",
    "Insurance",
    "Hydro",
    "Management Expenses",
    "Repairs",
    "Interest Charges",
    "General Expenses"
  ],
  profileStatus:[
    "Active",
    "Suspended",
    "Deactivated",
    "Disallowed",
    "Caution",
    "On Leave"
  ],
  userType:[
    "Unused",
    "Support User",
    "Regional Manager",
    "Administrator",
    "Associate",
    "Agent",
    "Broker(Owner)",
    "Firm Admin",
    "Sys Admin",
    "Passive",
    "Assistant"
  ],
  employmentIncomeType:[
    "Salary",
    "Hourly",
    "Hourly + Commissions",
    "Commissions",
    "Self-Employed",
    "Other Employment Income"
  ]
};

export default {
  dropdowns: dropdowns,
};
